module.exports = __webpack_public_path__ + "img/arbitrum.ded9bfc4.svg";